module.exports = __webpack_public_path__ + "static/halfling_ranger-7cd427c39921f971f4da12aed40ff198.png";